import {
    ESCAPE_KEY as SOURCE_ESCAPE_KEY
} from 'SourceComponent/Popup/Popup.config';

export const ESCAPE_KEY = SOURCE_ESCAPE_KEY;
